export default __webpack_public_path__ + "static/property-img5-468b2ca0cf17c98d1dd3e3d056055633.jpg";